
interface BeautyServiceCardProps {
    title: string;
    description: string;
    imagePath: string;
    duration: number;
  }
  
  export const BeautyServiceCard = ({
    title,
    description,
    imagePath,
    duration,
  }: BeautyServiceCardProps) => {
    return (
      <div className="flex items-center gap-5 self-stretch">
        <img
          src={imagePath}
          alt={imagePath}
          className="h-[100px] aspect-[61/100] rounded-[2px] object-cover"
        />
        <div className="flex flex-col ">
          <h3 className="text-[#CE0A2C] font-minion text-[20px] font-normal">
            {title}
          </h3>
          <p className="text-[#050505] text-justify font-minion text-[16px] font-normal leading-[150%]">
            {description}
          </p>
          <p className="text-[#050505] font-garamond-italic text-[14px] font-normal">
            {duration} min
          </p>
        </div>
      </div>
    );
  };
  